/**
 * @generated SignedSource<<1b22b9de1fe290210b3155537d342adc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentDeleted_pixQrCode$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  };
  readonly identifier: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkDeletedValue_pixQrCode">;
  readonly " $fragmentType": "PaymentDeleted_pixQrCode";
} | null | undefined;
export type PaymentDeleted_pixQrCode$key = {
  readonly " $data"?: PaymentDeleted_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentDeleted_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentDeleted_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaxID",
            "kind": "LinkedField",
            "name": "taxID",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxID",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "LOG"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkDeletedValue_pixQrCode"
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "abbb9c24cafd1735d2244d74a76d07fc";

export default node;
